/**
 * PROD1.7.8 N2 — Mapping des flags LLM (cas complexes).
 *
 * ⚠️ Synchronisation manuelle avec `backend/app/services/flags_policy.py`
 * (constante `ALLOWED_FLAGS`). Si tu ajoutes/retires un flag, mets à jour
 * les deux fichiers + le Prompt 1.3 en BD.
 */

export type FlagId =
  | 'multi_immeubles'
  | 'case_faillite'
  | 'multi_representants'
  | 'succession'
  | 'senc_associes'
  | 'procuration_notaire';

export interface FlagMeta {
  label: string;
  description: string;
  /** Palette Tailwind (bg + text + border) — cohérente entre flags. */
  className: string;
}

export const FLAG_META: Record<FlagId, FlagMeta> = {
  multi_immeubles: {
    label: 'Multi-immeubles',
    description:
      'Plusieurs immeubles dans la section DÉSIGNATION (Immeuble I / II), pouvant avoir des caractéristiques distinctes.',
    className: 'bg-purple-100 text-purple-800 border-purple-200',
  },
  case_faillite: {
    label: 'Faillite',
    description:
      'Vente sous séquestre / Loi sur la faillite (ordonnance de dévolution, syndic). Structure juridique atypique.',
    className: 'bg-red-100 text-red-800 border-red-200',
  },
  multi_representants: {
    label: 'Multi-représentants',
    description:
      '3+ personnes physiques avec rôles distincts (président, secrétaire, trésorier) dans le bloc vendeur ou acheteur.',
    className: 'bg-orange-100 text-orange-800 border-orange-200',
  },
  succession: {
    label: 'Succession',
    description:
      'Succession comme partie venderesse (liquidateur ou administrateur), même avec un seul liquidateur.',
    className: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  },
  senc_associes: {
    label: 'SENC associés',
    description:
      'SENC avec énumération explicite des associés ("dont les seuls associés sont :").',
    className: 'bg-teal-100 text-teal-800 border-teal-200',
  },
  procuration_notaire: {
    label: 'Procuration notaire',
    description:
      'Parties représentées par un notaire-mandataire via procuration sous seing privé (peut tromper l\'extraction).',
    className: 'bg-blue-100 text-blue-800 border-blue-200',
  },
};

export const ALL_FLAGS: FlagId[] = Object.keys(FLAG_META) as FlagId[];

export function isKnownFlag(flag: string): flag is FlagId {
  return flag in FLAG_META;
}
